import PropTypes from 'prop-types';
import { useState, useEffect, useCallback } from 'react';

import Box from '@mui/material/Box';

import PageAccessGate from 'src/components/page-access-gate';

import Nav from './nav';
import Main from './main';
import Header from './header';
import { NAV } from './config-layout';

const NAV_MINI_KEY = 'bsr-hr-nav-mini';

function readNavMini() {
  try {
    return localStorage.getItem(NAV_MINI_KEY) === '1';
  } catch {
    return false;
  }
}

// ----------------------------------------------------------------------

export default function DashboardLayout({ children }) {
  const [openNav, setOpenNav] = useState(false);
  const [navMini, setNavMini] = useState(readNavMini);

  useEffect(() => {
    try {
      localStorage.setItem(NAV_MINI_KEY, navMini ? '1' : '0');
    } catch {
      /* ignore */
    }
  }, [navMini]);

  const toggleNavMini = useCallback(() => setNavMini((v) => !v), []);
  const expandNav = useCallback(() => setNavMini(false), []);
  const navWidth = navMini ? NAV.WIDTH_MINI : NAV.WIDTH;

  return (
    <>
      <Header onOpenNav={() => setOpenNav(true)} navWidth={navWidth} />

      <Box
        sx={{
          minHeight: '100vh',
          width: '100%',
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
          bgcolor: 'transparent',
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Nav
          openNav={openNav}
          onCloseNav={() => setOpenNav(false)}
          navMini={navMini}
          onToggleMini={toggleNavMini}
          onExpandNav={expandNav}
        />

        <Main
          navWidth={navWidth}
          sx={{
            px: { xs: 1.5, sm: 2, lg: 2.5 },
            maxWidth: '100%',
            minWidth: 0,
            overflowX: 'hidden',
          }}
        >
          <PageAccessGate>{children}</PageAccessGate>
        </Main>
      </Box>
    </>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
};
